import React from "react";
import { Box, useTheme } from "@mui/material";
import CheckRoundedIcon from "@mui/icons-material/CheckRounded";
import PriorityHighRoundedIcon from "@mui/icons-material/PriorityHighRounded";
import ClearRoundedIcon from "@mui/icons-material/ClearRounded";

// Mini severity badge matching the Checks column chip (Amine, 2026-10-13):
// a colored rounded square with the white severity glyph. Shared by the
// ServiceChecksIndicator tooltips and the side-panel checks rows so every
// checks surface speaks the same chip language: passed → primary.main
// (teal) · warning → warning.main · error → error.main, white glyph.
const GLYPHS = {
  error: ClearRoundedIcon,
  warning: PriorityHighRoundedIcon,
  passed: CheckRoundedIcon,
};

const ChecksSeverityBadge = ({
  severity = "passed",
  size = 18,
  glyphSize = 12,
  radius = 5,
  sx,
}) => {
  const theme = useTheme();
  const Glyph = GLYPHS[severity] || GLYPHS.passed;
  const background =
    severity === "error"
      ? theme.palette.error.main
      : severity === "warning"
        ? theme.palette.warning.main
        : theme.palette.primary.main;
  return (
    <Box
      component="span"
      sx={{
        display: "inline-flex",
        alignItems: "center",
        justifyContent: "center",
        width: size,
        height: size,
        borderRadius: `${radius}px`,
        backgroundColor: background,
        lineHeight: 0,
        flexShrink: 0,
        ...sx,
      }}
    >
      <Glyph
        sx={{
          fontSize: glyphSize,
          display: "block",
          color: theme.palette.background.default,
        }}
      />
    </Box>
  );
};

export default ChecksSeverityBadge;
